import { cn } from '@/lib/utils'
import ResponsiveImage from '@/v2/components/helpers/responsive-image'
import SectionHead from '@/v2/components/sections/landing-pages/section-head'
import SectionWrapper from '@/v2/components/wrappers/section-wrapper'
import { fadeIn, staggerContainer } from '@/v2/constants/motion'
import { CardType } from '@/v2/types/cards'
import { domAnimation, LazyMotion, m } from 'framer-motion'
import React from 'react'

interface WhyChooseUsSectionProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string
  description?: string
  cards: CardType[]
}

const WhyChooseUsSection: React.FC<WhyChooseUsSectionProps> = props => {
  const { title, description, cards, className, ...rest } = props

  return (
    <LazyMotion features={domAnimation}>
      <m.section
        variants={staggerContainer(1, 0)}
        initial='hidden'
        whileInView='show'
        viewport={{ once: true, amount: 0.25 }}
        title={title}
        className={cn('text-center landing-pages-wr section-container section-spacing bg-secondary-first', className)}
      >
        <SectionWrapper {...rest}>
          <SectionHead title={title} description={description} />

          <div className='!grid lg-mn:grid-cols-3 md-mn:grid-cols-2 grid-cols-1 lg-mn:gap-[44px] gap-[20px] mb-[20px]'>
            {cards.map(card => {
              return (
                <m.article
                  variants={fadeIn('right', 'tween', 0, 1)}
                  key={card.id}
                  className='text-center bg-card rounded-lg border-[1.5px] border-border flex items-center flex-col lg-mn:p-[25px] p-[20px] [&>h3]:text-primary
          [&>h3]:font-[600] [&>h3]:text-[20px] [&>h3]:mb-[12px] [&>h3]:mt-[20px] '
                >
                  <ResponsiveImage src={card.image.src} alt={card.image.alt} className='w-[200px] h-[200px]' />
                  <h3>{card.title}</h3>
                  <p className='text-paragraph leading-[24px] font-[400] tex-[16px]'>{card.description}</p>
                </m.article>
              )
            })}
          </div>
        </SectionWrapper>
      </m.section>
    </LazyMotion>
  )
}
export default WhyChooseUsSection
